import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { IDEAL_DATE_COMPATIBILITY_OPTIONS } from '@/pages/Onboarding/options/IdealDateCompatibility/IDEAL_DATE_COMPATIBILITY_OPTIONS';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

export const ScreenIdealDate: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'IdealDate',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const idealDate = form.watch('ideal_date');

  const handleChange = (
    option: OnbOptionType<LayoutDataType['ideal_date']>,
  ) => {
    userService.createOrUpdate({
      onboarding_data: {
        idealDate: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <OnboardingPage background={'dark-solid'}>
      <OnboardingNavigation />

      <IonContent>
        <OwnAiTitle>What's your ideal date?</OwnAiTitle>
        <OnboardingOptionsList>
          {IDEAL_DATE_COMPATIBILITY_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={idealDate === option.id}
              control={form.control}
              option={option}
              name="ideal_date"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`ideal-date-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>
    </OnboardingPage>
  );
};
